"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateDataRevealedEvent = void 0;
class PrivateDataRevealedEvent {
    static fromMap(payload) {
        const event = new PrivateDataRevealedEvent();
        event.vehicleId = payload.vehicleId;
        event.userId = payload.userId;
        event.field = payload.field;
        return event;
    }
}
exports.PrivateDataRevealedEvent = PrivateDataRevealedEvent;
PrivateDataRevealedEvent.subject = 'private.data.revealed';
//# sourceMappingURL=PrivateDataRevealedEvent.js.map